/* BASIQ · Barra de compra fija: visible solo cuando el botón principal ha quedado por encima de la pantalla */
(function () {
  function setup(bar) {
    if (!bar || bar.dataset.ready === '1') return;
    bar.dataset.ready = '1';

    var root = bar.closest('[data-bp]') || document;
    var mainBtn = root.querySelector('[data-buy-btn]');
    var btn = bar.querySelector('[data-satc-btn]');
    var label = bar.querySelector('[data-satc-label]');
    var priceEl = bar.querySelector('[data-satc-price]');
    var cmpEl = bar.querySelector('[data-satc-compare]');
    var T = { add: bar.getAttribute('data-t-add'), sold: bar.getAttribute('data-t-sold') };
    if (!mainBtn || !btn) return;

    /* Mover la barra al <body> para que ningún contenedor la recorte */
    document.body.appendChild(bar);

    var visible = false;
    function setVisible(on) {
      if (on === visible) return;
      visible = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.setAttribute('tabindex', on ? '0' : '-1');
      document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
    }

    /* Aparece cuando el botón principal ya está por encima de la pantalla; desaparece al volver a verlo */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        setVisible(!en.isIntersecting && en.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(mainBtn);
    } else {
      window.addEventListener('scroll', function () {
        setVisible(mainBtn.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    /* Al pulsar, usa el botón principal (misma lógica de carrito, cantidad y carrito lateral) */
    btn.addEventListener('click', function () {
      if (btn.disabled || mainBtn.disabled) return;
      mainBtn.click();
    });

    /* Reflejar estados del botón principal: cargando / agotado */
    function sync() {
      btn.classList.toggle('is-loading', mainBtn.classList.contains('is-loading'));
      var sold = mainBtn.disabled || mainBtn.classList.contains('is-sold');
      btn.disabled = sold;
      btn.classList.toggle('is-sold', sold);
      if (label) label.textContent = sold ? T.sold : T.add;
    }
    new MutationObserver(sync).observe(mainBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });

    /* Cambio de variante: precio */
    root.addEventListener('bp:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      if (priceEl && v.price) priceEl.textContent = v.price;
      if (cmpEl) {
        if (v.compare) { cmpEl.textContent = v.compare; cmpEl.hidden = false; }
        else { cmpEl.hidden = true; }
      }
      setTimeout(sync, 0);
    });

    sync();
  }

  function initAll(r) {
    (r || document).querySelectorAll('[data-bp-satc]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Editor: al recargar la sección, quitar la barra antigua del <body> y volver a montar */
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target.querySelector('[data-bp]')) return;
    document.querySelectorAll('body > [data-bp-satc]').forEach(function (b) { b.remove(); });
    document.body.style.paddingBottom = '';
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
